<template>
  <Box :class="classes" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)">
    <slot name="default"></slot>
  </Box>
</template>

<script>

export default {
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    },
    verticalAlignment: {
      type: String
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-stack-layout',
        'orientation-' + this.orientation
      ]

      if (this.verticalAlignment) classes.push('vertical-alignment-' + this.verticalAlignment)

      return classes.join(' ')
    }
  },
  watch: {
    orientation: {
      immediate: true,
      handler (to) {
        this.$nextTick(() => {
          this.$el.style.flexDirection = to
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-stack-layout {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .web-stack-layout::v-deep.orientation-vertical > * {
    width: -webkit-fill-available;
    width: -moz-available;
  }

  .web-stack-layout.orientation-horizontal {
    flex-direction: row;
  }

  .web-stack-layout.vertical-alignment-top {
    justify-content: flex-start;
  }

  .web-stack-layout.vertical-alignment-center,
  .web-stack-layout.vertical-alignment-middle {
    justify-content: center;
  }

  .web-stack-layout.vertical-alignment-bottom {
    justify-content: flex-end;
  }
}

</style>